import { Injectable, computed, signal } from '@angular/core';
import { ICalGtmBaseEvent } from '@cal-analytics/gtm';
import { IAlertConfig, IConfirmConfig, ITooltipConfig } from '@partners/ui';
import { IGtmDialogConfig } from '../../models';
import { GtmPartnersService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class GtmGenericDialogsService extends GtmPartnersService {
  protected step_title = 'popup';
  protected step_number = 100;
  protected error_type = 'NA';
  protected sub_process_type = 'NA';

  protected readonly _dialogConfig = signal<IAlertConfig | IConfirmConfig | ITooltipConfig>(undefined);

  override getBaseEvent(): ICalGtmBaseEvent {
    return this.baseEvent()?.['popupPage'];
  }

  override baseEvent = computed(() => {
    return {
      popupPage: {
        ...this.baseEvent$$(),
        step_title: `${this.step_title}: ${this._dialogConfig()?.message || this._dialogConfig()?.title}`,
        step_number: this.step_number,
        sub_process_type: this.sub_process_type
      }
    };
  });

  override funnelStep = computed(() => ({
    funnelStepEvent: {
      ...this.baseFunnelStep$$(),
      error_type: this.error_type
    }
  }));

  override funnelClick = computed(() => ({
    okClickEvent: {
      component_type: 'button',
      click_text: (<{ ok?: string }>this._dialogConfig()?.buttons)?.ok || 'המשך',
      question_text: 'NA'
    },
    cancelClickEvent: {
      component_type: 'text',
      click_text: (<{ confirm: string; cancel: string }>this._dialogConfig()?.buttons)?.cancel || 'ביטול',
      question_text: 'NA'
    },
    confirmClickEvent: {
      component_type: 'button',
      click_text: (<{ confirm: string; cancel: string }>this._dialogConfig()?.buttons)?.confirm || 'אישור',
      question_text: 'NA'
    }
  }));

  setDialogConfig(dialogConfig: IGtmDialogConfig) {
    this._dialogConfig.set(dialogConfig);
  }
}
